/* eslint-disable no-undef */
/* eslint-disable react/destructuring-assignment */
import React from 'react';
import withTranslate from 'react-redux-multilingual/lib/withTranslate';
import { newsIdMap } from 'Actions/NewsActions';
import InsightItem from 'components/WCInsightList/InsightItem/InsightItem';
import './InsightsAccountOverview.scss';
import {
	Row,
	Col
} from 'reactstrap';

class InsightAccountOverview extends React.Component {
	QuoteCards = [];

	render() {
		const {
			translate
		} = this.props;

		return (
			<div className="markets-insight-list">
				<Row noGutters>
					<Col>
						<p role="document" className="description">
							{translate('insightDescription')}
						</p>
					</Col>
				</Row>
				<Row noGutters>
					<InsightItem
						newsId={newsIdMap.morningNewsId}
						heading={translate('morningNewsCallWC')}
						iconName="bullHornTransparent" />
					<InsightItem
						newsId={newsIdMap.usMorningNewsId}
						heading={translate('usMorningNewsCallWC')}
						iconName="bullHornTransparent" />
					<InsightItem
						newsId={newsIdMap.weekAheadNewsId}
						heading={translate('theWeekAheadWC')}
						iconName="reports" />
				</Row>
			</div>
		);
	}
}

export default withTranslate(InsightAccountOverview);
